import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import type {SalesDocumentVariant} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {useCreateSalesDocument} from '../../lead/sales-documents/shared/graphql/hooks/use-create-sales-document';

import {SelectRelatedLeadForm} from './select-related-lead-form';

type Props = {
    entityType: SalesDocumentVariant;
};

export function SalesDocumentForm(props: Props) {
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string | null | undefined>(null);

    const {createSalesDocument} = useCreateSalesDocument();

    const handleCreateQuoteOrInvoice = (leadId: string) => {
        setIsLoading(true);
        createSalesDocument({
            leadId,
            salesDocumentVariant: props.entityType,
        })
            .then((response) => {
                setError(null);
                const modalHash =
                    response.data && response.data.salesDocumentCreate.salesDocument
                        ? response.data.salesDocumentCreate.salesDocument.modalUrl
                        : null;
                if (modalHash) {
                    appHistory.replace({
                        ...appHistory.location,
                        hash: modalHash,
                        state: {modal: true},
                    });
                    window.dispatchEvent(new CustomEvent('salesDocumentCreated'));
                    window.dispatchEvent(new Event('onboarding-step-completed'));
                }
            })
            .catch(() => {
                setError(
                    `Failed to create a ${props.entityType.toLowerCase()}, please refresh and try again.`
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className='full-height my-8'>
            {isLoading ? (
                <div className='full-height mb-64'>
                    <LoadingPage />
                </div>
            ) : (
                <StackLegacy spacing={24}>
                    {error ? (
                        <Body size='small' color='error'>
                            {error}
                        </Body>
                    ) : (
                        <Body size='small' color='dark'>
                            Please select a lead to add{' '}
                            {props.entityType === 'QUOTE' ? 'a quote' : 'an invoice'}
                        </Body>
                    )}
                    <SelectRelatedLeadForm onSelect={handleCreateQuoteOrInvoice} />
                </StackLegacy>
            )}
        </div>
    );
}
